import UserListView from "../components/UserListView";
import { useSelector, useDispatch } from "react-redux";
import { useContext, useEffect, useState } from "react";
import {
  getFollowerSuggestion,
  getFollowersList,
} from "../store/actions/userActions";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage, followerApiStatus } from "../shared/const.prop";
import Loader from "../components/Loader";
import NoDataAvailable from "../components/NoDataAvailable";
import { Link } from "react-router-dom";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
const MyNetwork = () => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { followers, followerSuggestion } = useSelector((state) => state.user);
  const [followerList, setFollowerList] = useState(followers);
  const [followerSuggestionList, setFollowerSuggestionList] =
    useState(followerSuggestion);
  const [isFollowersFetched, setIsFollowersFetched] = useState(false);
  const [isFollowerSuggestionFetched, setIsFollowerSuggestionFetched] =
    useState(false);
  const handleRequest = async (userId, status, follower) => {
    try {
      const followApi = await axiosHttp.post("follow", {
        userId,
        status,
      });
      if (followApi.status === 201) {
        [followerApiStatus.accept, followerApiStatus.cancel].includes(status)
          ? dispatch(getFollowersList())
          : dispatch(getFollowerSuggestion());
        dispatch(getActiveNotificationCount());
        if (
          followerApiStatus.request.includes(status) &&
          follower.length !== 0
        ) {
          dispatch(getFollowersList());
        }
        if (status === followerApiStatus.accept) {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `Accepted follow request from ${follower?.fName} ${follower?.lName}`,
          });
        } else if (status === followerApiStatus.cancel) {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `Cancelled follow request from ${follower?.fName} ${follower?.lName}`,
          });
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "success",
            message: `You gave  follow request to ${follower?.fName} ${follower?.lName}`,
          });
        }
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (
        e.response.status === 422 &&
        e.response.message ===
          "You have already sent a follow request to this user."
      ) {
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Request sent waiting for conformation",
        });
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Error, please try after sometime.",
      });
    }
  };
  useEffect(() => {
    dispatch(getFollowersList());
    dispatch(getFollowerSuggestion());
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  useEffect(() => {
    const d = followers.slice(0, 6);
    setFollowerList(d);
    setIsFollowersFetched(true);
  }, [followers]);
  useEffect(() => {
    const d = Object.values(followerSuggestion).slice(0, 6);
    setFollowerSuggestionList(d);
    setIsFollowerSuggestionFetched(true);
  }, [followerSuggestion]);

  return (
    <>
      <div className="card card-one-1">
        <div className="card-body">
          <p className="title">
            {/* <a href="post.html" className="arrow mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M16.6667 10.2285C16.6667 10.5449 16.4316 10.8064 16.1266 10.8478L16.0417 10.8535L5.05508 10.853L9.02424 14.8059C9.26884 15.0495 9.26969 15.4452 9.02614 15.6898C8.80473 15.9122 8.45755 15.9331 8.21249 15.7521L8.14226 15.6917L3.10059 10.6717C3.06835 10.6396 3.04035 10.6049 3.01658 10.5682C3.00986 10.5571 3.00303 10.5458 2.99655 10.5343C2.99059 10.5244 2.98521 10.5142 2.98013 10.5038C2.97307 10.4887 2.96618 10.4731 2.95992 10.4572C2.95483 10.445 2.95059 10.433 2.94671 10.421C2.94211 10.4061 2.93764 10.3902 2.93379 10.3741C2.93093 10.3628 2.92866 10.352 2.92668 10.3411C2.9239 10.3249 2.92154 10.3081 2.91985 10.2912C2.91839 10.2782 2.91752 10.2654 2.91703 10.2526C2.91691 10.2448 2.91675 10.2367 2.91675 10.2285L2.91706 10.2043C2.91754 10.192 2.91838 10.1798 2.91958 10.1675L2.91675 10.2285C2.91675 10.1891 2.9204 10.1505 2.92739 10.1131C2.92901 10.1041 2.93094 10.095 2.93308 10.0858C2.93752 10.067 2.94265 10.0489 2.94855 10.0311C2.95146 10.0223 2.95483 10.0129 2.95844 10.0035C2.96575 9.98471 2.97369 9.96678 2.98242 9.94932C2.98648 9.94111 2.99102 9.93251 2.99578 9.924C3.00359 9.91012 3.01163 9.89693 3.02014 9.88407C3.02614 9.87497 3.03279 9.8655 3.03973 9.85617L3.04514 9.84897C3.06198 9.82697 3.08025 9.80612 3.09981 9.78657L3.10056 9.78599L8.14222 4.76515C8.3868 4.52158 8.78253 4.5224 9.0261 4.76698C9.24753 4.98933 9.26699 5.33659 9.08493 5.58089L9.02427 5.65086L5.05675 9.60301L16.0417 9.60351C16.3869 9.60351 16.6667 9.88333 16.6667 10.2285Z"
                  fill="black"
                  fillOpacity="0.6"
                />
              </svg>
            </a> */}
            Followers
          </p>
          {/* <p className="sub-txt">This Week</p> */}
          {followerList.length ? (
            <>
              {followerList.map((follower, index) => (
                <UserListView key={index} user={follower}>
                  {follower?.followStatus === "R" && (
                    <div className="d-flex">
                      <div className="">
                        <button
                          type="button"
                          className="btn btn-primary prim-btn mr-4"
                          onClick={() =>
                            handleRequest(
                              follower.userId,
                              followerApiStatus.accept,
                              follower
                            )
                          }
                        >
                          Confirm
                        </button>
                      </div>
                      <div className="">
                        <button
                          type="button"
                          className="btn btn-secondary del-btn"
                          onClick={() =>
                            handleRequest(
                              follower.userId,
                              followerApiStatus.cancel,
                              follower
                            )
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}
                  {follower?.isFollowingBack === false &&
                    follower?.followingBackRequest !== "R" && (
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn btn-outline-primary follow-btn"
                          onClick={() =>
                            handleRequest(
                              follower.userId,
                              followerApiStatus.request,
                              follower
                            )
                          }
                        >
                          Follow
                        </button>
                      </div>
                    )}
                </UserListView>
              ))}
              {followerList.length > 5 ? (
                <p className="text-center">
                  <Link to="../people">See More</Link>
                </p>
              ) : null}
            </>
          ) : isFollowersFetched ? (
            <NoDataAvailable />
          ) : (
            <Loader />
          )}
          <p className="sug-font">Suggested for you</p>
          {followerSuggestionList.length ? (
            <>
              {followerSuggestionList.map((followerSuggestion, index) => (
                <UserListView key={index} user={followerSuggestion}>
                  <div className="d-flex">
                    <button
                      type="button"
                      className="btn btn-outline-primary follow-btn"
                      onClick={() =>
                        handleRequest(
                          followerSuggestion.userId,
                          followerApiStatus.request
                        )
                      }
                    >
                      Follow
                    </button>
                    {/* <span className="ml-3 cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.75806 17.2428L12.0011 11.9998L17.2441 17.2428M17.2441 6.75684L12.0001 11.9998L6.75806 6.75684"
                      stroke="black"
                      strokeOpacity="0.5"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span> */}
                  </div>
                </UserListView>
              ))}
              {followerSuggestionList.length > 5 ? (
                <p className="text-center">
                  <Link to="../suggested-followers">See More</Link>
                </p>
              ) : null}
            </>
          ) : followerList.length ? (
            (isFollowerSuggestionFetched && <NoDataAvailable />) || <Loader />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default MyNetwork;
